// Enum values mirrored from the Libertify OpenAPI spec
// (https://api.libertify.com/media/openapi.json).
//
// Whenever the API adds new values, update these arrays so the playground
// dropdowns stay in sync. Each constant is named to match the API schema.

export const TONE_IDS = [
  'Authoritative',
  'Conversational',
  'Empathetic',
  'Enthusiastic',
  'Formal',
  'Humorous',
  'Instructive',
  'Motivational',
  'Neutral',
  'Persuasive',
  'Professional',
  'Storytelling',
] as const;
export type ToneId = (typeof TONE_IDS)[number];

export const STORYBOARD_GENERATION_MODES = ['Standard', 'Translate', 'Transcript'] as const;
export type StoryboardGenerationMode = (typeof STORYBOARD_GENERATION_MODES)[number];

export const OBJECTIVES = ['Persuade', 'Onboard', 'Inform', 'Learn', 'Retain', 'Engage', 'Support'] as const;
export type Objective = (typeof OBJECTIVES)[number];

export const TRANSITIONS = ['Basic', 'NoTransition'] as const;
export type Transition = (typeof TRANSITIONS)[number];

export const MEDIA_GENERATION_MODES = ['Video', 'Audio', 'Podcast', 'Disabled'] as const;
export type MediaGenerationMode = (typeof MEDIA_GENERATION_MODES)[number];

export const CHAT_MODES = ['FullChat', 'SourcesOnly', 'Disabled'] as const;
export type ChatMode = (typeof CHAT_MODES)[number];

export const PUBLICATION_MODES = ['PublicLink', 'PinByEmail', 'PasswordProtected'] as const;
export type PublicationMode = (typeof PUBLICATION_MODES)[number];

export const DOCUMENT_TYPES = [
  'Unknown',
  'EquityResearch',
  'FundsPresentation',
  'PortfolioReview',
  'IpoDocument',
  'BankResearch',
  'CompanyFinancialPublication',
  'News',
  'Positions',
  'HomeInsurance',
  'PitchDeck',
  'WebPage',
  'ECommerceProductPage',
  'ECommerceProductInformations',
  'Report',
] as const;
export type DocumentType = (typeof DOCUMENT_TYPES)[number];

export const VOICE_PROVIDER_IDS = ['high_quality_01', 'high_quality_asian'] as const;
export type VoiceProviderId = (typeof VOICE_PROVIDER_IDS)[number];

export const VOICE_CATEGORIES = ['Premade', 'Professional', 'Cloned'] as const;
export type VoiceCategory = (typeof VOICE_CATEGORIES)[number];

export const FACE_CATEGORIES = ['Premade', 'Custom'] as const;
export type FaceCategory = (typeof FACE_CATEGORIES)[number];

export const LANGUAGE_OPTIONS = [
  { code: 'en-US', label: 'English (US)', flag: '🇺🇸' },
  { code: 'en-GB', label: 'English (UK)', flag: '🇬🇧' },
  { code: 'fr-FR', label: 'French', flag: '🇫🇷' },
  { code: 'de-DE', label: 'German', flag: '🇩🇪' },
  { code: 'es-ES', label: 'Spanish', flag: '🇪🇸' },
  { code: 'it-IT', label: 'Italian', flag: '🇮🇹' },
  { code: 'pt-PT', label: 'Portuguese', flag: '🇵🇹' },
  { code: 'nl-NL', label: 'Dutch', flag: '🇳🇱' },
  { code: 'ja-JP', label: 'Japanese', flag: '🇯🇵' },
  { code: 'ko-KR', label: 'Korean', flag: '🇰🇷' },
  { code: 'zh-CN', label: 'Chinese (Simplified)', flag: '🇨🇳' },
] as const;
